export default class DataModuleBaseUtils {
  comparisonLabel = ({districtAverage, totalStudents}) => {
    if (totalStudents < 5) {
      return 'Next Milestone';
    } else if (!districtAverage) {
      return 'Raise Me Avg';
    }

    return 'District Avg';
  };

  emptyStateBodyHeader = () => 'Next Step';

  emptyStateBodyContent = () =>
    'Invite 5 more students to start helping your students earn money toward college.';
}
